import { Icons } from "./Icons/Icons";
import { useEffect, useState } from "react";
import { GLCalendar } from "./GLCalendar";
import { IHeaderSetters } from "../Journal";
import React from "react";


export function AppHeader({ updateHeader }:
    { updateHeader?: (setters: IHeaderSetters) => void }) {

    const [stateHeaderTitle, setHeaderTitle] = React.useState<string>("");
    const [stateSubtitle, setSubtitle] = React.useState<string>("");
    const [stateHeaderDate, setHeaderDate] = React.useState<string>("");
    const [stateIsReadyToRender, setIsReadyToRender] = React.useState<boolean>(false);
    const [stateCalendarVisible, setVisible] = useState(false);


    const headerSetters = {
        clear: () => { setSubtitle(" "); setHeaderTitle(""); setHeaderDate(" "); setIsReadyToRender(false); },
        setHeaderTitle: setHeaderTitle,
        setSubtitle: setSubtitle,
        setHeaderDate: setHeaderDate,
        setIsReadyToRender: setIsReadyToRender
    };

    useEffect(() => {
        updateHeader && updateHeader(headerSetters);
    }, []);

    if (!stateIsReadyToRender)
        return <></>;

    return (
        <div className="gl-header flex-none flex flex-column justify-content-end pb-0">
            <div className="h-full flex flex-row justify-content-between align-items-centers">
                <div className="flex flex-row align-items-center justify-content-start">
                    <Icons.TitleIcon />
                    <p className="HeaderTitle gl-app-title-typography m-0">{stateHeaderTitle}</p>
                </div>
                <div onClick={() => setVisible(true)}>
                    <Icons.CalendarIcon className="flex-none" />
                </div>
            </div>
            <div className="gl-header-subtitle-row mt-75 flex flex-row justify-content-between align-items-end">
                <p className="HeaderSubtitle m-0">{stateSubtitle}</p>
                <p className="HeaderDate gl-popup-body-typography m-0">{stateHeaderDate}</p>
            </div>


            <GLCalendar
                show={stateCalendarVisible}
                onHideCallback={() => setVisible(false)}
            />

        </div>
    );
}